import React from 'react';
import './ChatBubble.css';

const ChatBubble = ({ role, content, isStreaming }) => {
    const isUser = role === 'user';

    return (
        <div className={`chat-bubble-row chat-bubble-row--${isUser ? 'user' : 'assistant'}`}>
            <div className={`chat-bubble chat-bubble--${isUser ? 'user' : 'assistant'}`}>
                <span className='chat-bubble__text'>{content}</span>
                {isStreaming && <span className='chat-bubble__caret' aria-hidden='true' />}
            </div>
        </div>
    );
};

export default ChatBubble;
